import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError, IMAGES } from "../lib/api";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Les mots de passe ne correspondent pas");
      return;
    }
    setSubmitting(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      toast.success(data.message);
      navigate("/connexion");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="reset-password-page">
      <div className="text-center mb-10">
        <img src={IMAGES.logo} alt="Italian Club" className="h-20 w-20 object-contain rounded-full bg-white/95 p-1 mx-auto mb-4" />
        <h1 className="font-serif-elegant text-4xl font-bold">Définir le mot de passe</h1>
        <p className="text-sm text-gray-400 mt-2">Choisissez votre nouveau mot de passe</p>
      </div>
      {!token ? (
        <div className="text-center space-y-4">
          <p className="text-gray-400 text-sm">Lien invalide. Refaites une demande de réinitialisation depuis la page de connexion.</p>
          <Link to="/connexion" className="btn-outline-gold inline-flex !py-2.5 text-sm">Retour à la connexion</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="reset-password-input" required type="password" minLength={6} className="ic-input" placeholder="Nouveau mot de passe (min 6) *" value={password} onChange={(e) => setPassword(e.target.value)} />
          <input data-testid="reset-password-confirm" required type="password" minLength={6} className="ic-input" placeholder="Confirmer le mot de passe *" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          <button type="submit" disabled={submitting} data-testid="reset-password-submit" className="btn-gold w-full !py-3.5 disabled:opacity-50">
            {submitting ? "Un instant…" : "Enregistrer le nouveau mot de passe"}
          </button>
        </form>
      )}
    </div>
  );
}
